import { doc, getDoc, setDoc, Timestamp, updateDoc } from 'firebase/firestore';
import { db, auth } from './config';
import type { ThreeCirclesConfig } from '../../types/threeCircles';

function circlesRef(uid: string) {
  return doc(db, 'users', uid, 'threeCircles', 'config');
}

export async function getThreeCircles(uid: string): Promise<ThreeCirclesConfig | null> {
  if (!auth.currentUser) throw new Error('Not authenticated');
  const snap = await getDoc(circlesRef(uid));
  if (!snap.exists()) return null;
  const data = snap.data();
  // Normalize — documents created before array initialization may be missing these fields
  return {
    enabled: data.enabled ?? false,
    outerCircle: Array.isArray(data.outerCircle) ? data.outerCircle : [],
    middleCircle: Array.isArray(data.middleCircle) ? data.middleCircle : [],
    innerCircle: Array.isArray(data.innerCircle) ? data.innerCircle : [],
    updatedAt: data.updatedAt,
  } as ThreeCirclesConfig;
}

export async function saveThreeCircles(
  uid: string,
  config: Omit<ThreeCirclesConfig, 'updatedAt'>
): Promise<void> {
  if (!auth.currentUser) throw new Error('Not authenticated');
  await setDoc(circlesRef(uid), { ...config, updatedAt: Timestamp.now() });
}

export async function toggleThreeCircles(uid: string, enabled: boolean): Promise<void> {
  if (!auth.currentUser) throw new Error('Not authenticated');
  const ref = circlesRef(uid);
  const snap = await getDoc(ref);
  if (!snap.exists()) {
    // First-time enable — create document with all required arrays initialized
    await setDoc(ref, {
      enabled,
      outerCircle: [],
      middleCircle: [],
      innerCircle: [],
      updatedAt: Timestamp.now(),
    });
  } else {
    await updateDoc(ref, { enabled, updatedAt: Timestamp.now() });
  }
}
